import React from "react";
import { useUploadProgressToast } from "../hooks/useUploadProgressToast";

export function UploadProgressProvider({ children }: { children: React.ReactNode }) {
  useUploadProgressToast();
  return <>{children}</>;
}
